const formatter = new Intl.DateTimeFormat('en-US', {
  day: '2-digit',
  month: '2-digit',
  timeZone: 'UTC',
});

/** Format a date as "MM/DD" in UTC. */
export const formatMMDDUtc = (
  date: Date | string | undefined | null,
): string => {
  if (date == null) {
    return '';
  }
  const parsed = new Date(date);
  return isNaN(parsed.getTime()) ? '' : formatter.format(parsed);
};
